import { render, staticRenderFns } from "./MctPlot.vue?vue&type=template&id=35be6672&"
import script from "./MctPlot.vue?vue&type=script&lang=js&"
export * from "./MctPlot.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports